import lowerFirst from "./lowerFirst";

/**
 * @param {string} prefix
 * @param {string} value
 */
export default function unPrefixPropName(prefix, value) {
    return lowerFirst(value.replace(prefix, ""));
}



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/lib/utils/unPrefixPropName.js
// module id = 122
// module chunks = 2